import React, { useMemo } from 'react'
import cx from 'classnames'
import { constants } from 'helpers'
import { useFt } from 'hooks'

import HeroSection, { type HeroSectionProps } from './components/HeroSection/HeroSection'
import ProductsSection, { type ProductsSectionProps } from './components/ProductsSection/ProductsSection'


type ScentbirdSelectBlockProps = {
  className?: string
  excludeId?: number
  metadata?: Partial<QueueModule.AddItemInput['metadata']>
  title?: HeroSectionProps['title']
  description?: HeroSectionProps['description']
  productsCarouselType?: ProductsSectionProps['type']
  withBrowseButton?: ProductsSectionProps['withBrowseButton']
  withNonAuthRedirect?: ProductsSectionProps['withNonAuthRedirect']
  withoutLink?: ProductsSectionProps['withoutLink']
}

const ScentbirdSelectBlock: React.FunctionComponent<ScentbirdSelectBlockProps> = (props) => {
  const { className, excludeId, metadata = {}, title, description,
    productsCarouselType, withBrowseButton, withNonAuthRedirect, withoutLink } = props

  const isEnabled = useFt(constants.features.collaborationSaks)

  const mergedMetadata = useMemo(() => {
    return {
      placement: 'Scentbird select block',
      ...metadata,
    }
  }, [ metadata ])

  if (!isEnabled) {
    return null
  }

  return (
    <div className={cx(className, 'bg-[#eedfd3]')}>
      <HeroSection title={title} description={description} />
      <ProductsSection
        excludeId={excludeId}
        metadata={mergedMetadata}
        type={productsCarouselType}
        withBrowseButton={withBrowseButton}
        withNonAuthRedirect={withNonAuthRedirect}
        withoutLink={withoutLink}
      />
    </div>
  )
}

export default ScentbirdSelectBlock
